import { Box } from '@material-ui/core'
import { ClosableDialog, ClosableDialogProps } from 'components/controls/dialogs'
import { useHandleSettingsChange } from 'components/domain/stockPricing/StockPricingPresenter'
import { useUser } from 'components/providers/UserProvider'
import { createUserSubEntity } from 'lib/api'
import { getUniqueNewName } from 'lib/utils'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { CreateCompetitorPresenter } from './CreateCompetitorPresenter'

export const CreateCompetitorDialog = ({ onClose, open }: ClosableDialogProps): JSX.Element => {
  const { user } = useUser()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  if (!user) return <></>

  const handleChange = useHandleSettingsChange()
  return (
    <ClosableDialog maxWidth="lg" onClose={onClose} open={open}>
      <Box width={1000}>
        <h4>
          {t('competitor.create.title')}{' '}
          {/* <RestartButton
          onClick={() => {
            if (onRestart) onRestart()
            else {
              setCompetitor(defaultValues)
              setProgress(1)
              setStep(1)
            }
          }}
          dataTestid={'restart-btn'}
        /> */}
        </h4>
        <CreateCompetitorPresenter
          newName={getUniqueNewName(`New Competitor`, user?.competitors)}
          onDone={async (strategy) => {
            const ok = await handleChange(() => createUserSubEntity(strategy, 'competitors'))
            if (!ok) return
            enqueueSnackbar(t('competitor.create.success'), { variant: 'success' })
            onClose({}, 'escapeKeyDown')
          }}
        />
      </Box>
    </ClosableDialog>
  )
}
